import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex w-full flex-col gap-3" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { class: "relative flex flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách văn bản" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          value: $setup.listDocumentProcess,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10, 25, 50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          filters: $setup.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
          globalFilterFields: ['title', 'sender'],
          currentPageReportTemplate: "Có tổng số {totalRecords} văn bản",
          resizableColumns: "",
          tableclass: "h-[60px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-filter-slash",
                    label: "Xoá lọc",
                    outlined: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter()))
                  }),
                  _createElementVNode("span", _hoisted_5, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                    _createVNode(_component_InputText, {
                      class: "!w-[500px] !pl-10 !pr-3",
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      placeholder: "Tìm theo tên hoặc số điện thoại"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "title",
              header: "Tiêu đề văn bản",
              sortable: "",
              class: "h-[60px]"
            }),
            _createVNode(_component_Column, {
              field: "sender",
              header: "Người gởi",
              class: "h-[60px]",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "time",
              header: "Thời gian",
              class: "h-[60px]",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.time)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "status",
              header: "Trạng thái",
              class: "h-[60px]",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.status)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      outlined: "",
                      label: "Đã xử lý",
                      icon: "pi pi-check",
                      onClick: ($event: any) => ($setup.goToViewDocument(slotProps.data.id))
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      outlined: "",
                      severity: "danger",
                      label: "Chưa xử lý",
                      icon: "pi pi-hourglass",
                      onClick: ($event: any) => ($setup.goToViewDocument(slotProps.data.id))
                    }, null, 8, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"])
      ])
    ]),
    _: 1
  }))
}